import Page, { PageActionsType } from "components/common/page/Page";
import { useState } from "react";
import { SeasonType } from "types/season-type";
import useAppContext from "utilities/hooks/useAppContext";
import { AppRoutes, URI_PARAMETER_KEYS } from "@/config/router";
import { useParams } from "react-router-dom";
import Tabs from "@/components/common/tabs/Tabs";
import Tab from "@/components/common/tabs/Tab";
import AccommodationLastNYeasStats from "@/components/entities/accommodation/booking/stats/AccommodationLastNYeasStats";
import AccommodationOverviewStatistics from "@/components/entities/accommodation/booking/stats/AccommodationOverviewStatistics";
import { faFilter, faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons";
import ModalPortal from "@/components/modal/ModalPortal";
import AcommodationStatsFilterForm, { AcommodationStatsFilterFormSubmitModel } from "@/components/entities/accommodation/booking/stats/AcommodationStatsFilterForm";
import AccommodationStatsMonthly from "@/components/entities/accommodation/booking/stats/AccommodationStatsMonthly";

const FILTER_MODAL_NAME = 'filterModal';

const AccommodationOverviewStatisticsPage = () => {
  var params = useParams<{ [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: string, filterMonth?: string, filterDates?: string }>();
  const targetSeasonId = params[URI_PARAMETER_KEYS.TARGET_SEASON_ID];
  const context = useAppContext();
  const [season, setSeason] = useState<SeasonType>({
    active: true,
    id: -1,
    name: context.t("common.active"),
  });

  const pageActions: PageActionsType = [
    {
      icon: faFilterCircleXmark,
      name: 'resetFilter',
      hide: !targetSeasonId,
      title: context.t("common.resetFilter"),
      link: () => {
        context.navigate(AppRoutes.ACCOMMODATION_OVERVIEW_OVERVIEW);
      }
    },
    {
      icon: faFilter,
      name: 'filter',
      title: context.t("common.filter"),
      link: () => {
        context.modal.open(FILTER_MODAL_NAME);
      }
    }
  ];

  function onFormSubmit(model: AcommodationStatsFilterFormSubmitModel) {
    const filterMonth = model.monthId || '';
    const filterDate = model.dateRange || '';

    const queryParams = `?monthFilter=${filterMonth}&filterDate=${filterDate}&untilDate=${model.untilDate || ''}&filterType=${model.filterType || ''}`;

    if (model.seasonId == -1) {
      context.navigate(AppRoutes.ACCOMMODATION_OVERVIEW_OVERVIEW + queryParams);
    } else {
      context.navigate(AppRoutes.ACCOMMODATION_SEASON_OVERVIEW_OVERVIEW + queryParams, { targetSeasonId: model.seasonId });
    }
  }

  return (
    <>
      <Page title={`${context.t("pages.accommodation.overview")} - ${season?.name}`} actions={pageActions} wFull>
        <Tabs activeTab="">
          <Tab name="stats" title={context.t("pages.accommodation.stats.currentYear")}>
            <AccommodationOverviewStatistics
              targetSeasonId={targetSeasonId}
              setSeason={setSeason}
            />
          </Tab>
          <Tab name="charts-monthly" title={context.t("pages.accommodation.stats.monthly")}>
            <AccommodationStatsMonthly seasonId={season?.id} />
          </Tab>
          <Tab name="charts" title={context.t("pages.accommodation.stats.last5Years")}>
            <AccommodationLastNYeasStats seasonId={season?.id} />
          </Tab>
        </Tabs>
      </Page>
      <ModalPortal name={FILTER_MODAL_NAME} title={context.t("common.filter")}>
        <div className="min-h-[50dvh] md:min-h-auto">
          <AcommodationStatsFilterForm name={FILTER_MODAL_NAME} onReset={() => context.modal.close(FILTER_MODAL_NAME)} season={season} onSumit={onFormSubmit}  />
        </div>
      </ModalPortal>
    </>
  );
};

export default AccommodationOverviewStatisticsPage;
